import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/Index.vue'




const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,

    meta: {
      title: 'Bestauros Thomas',
      metaTags: [
        {
          name: 'description',
          content: 'I’m a full-stack developer & designer based in France. I build apps for a variety of platforms; including web & mobile.'
        },
        {
          property: 'og:description',
          content: 'I’m a full-stack developer & designer based in France. I build apps for a variety of platforms; including web & mobile.'
        }
      ]
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),

    meta: {
      title: 'About - Bestauros Thomas',
      metaTags: [
        {
          name: 'description',
          content: 'I’m a full-stack developer & designer based in France. I build apps for a variety of platforms; including web & mobile.'
        },
        {
          property: 'og:description',
          content: 'I’m a full-stack developer & designer based in France. I build apps for a variety of platforms; including web & mobile.'
        }
      ]
    },
  },
  {
    path: '/work',
    name: 'Work',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Work.vue'),

    meta: {
      title: 'Work - Bestauros Thomas',
      metaTags: [
        {
          name: 'description',
          content: 'Take a look at what I ve been working on!'
        },
        {
          property: 'og:description',
          content: 'Take a look at what I ve been working on!'
        }
      ]
    },
  },



  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),

    meta: {
      title: 'Contact - Bestauros Thomas',
      metaTags: [
        {
          name: 'description',
          content: 'Every project starts with a talk. Just write me an email and let s bring your ideas into the life.'
        },
        {
          property: 'og:description',
          content: 'Every project starts with a talk. Just write me an email and let s bring your ideas into the life.'
        }
      ]
    },
  },


  {
  path: '/jbfilms',
  name: 'Jbfilms',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ '../views/projetcs/jbfilms.vue')
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    setTimeout(() => {
    window.scrollTo(0,0);
  }, 500)
  }
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
